/**
 * This hook uses function overloads to provide a flexible way to send tracking events to Snowplow.
 * The hook can be instantiated with or without a tracking label.
 * https://www.typescriptlang.org/docs/handbook/2/functions.html#function-overloads
 *
 * If a tracking label is provided on instantiation, the hook will return a function that can be called
 * with the rest of the tracking event properties, but not with a tracking label.
 *
 * If a tracking label is not provided on instantiation, the hook will return a function that can be
 * called with all the tracking event properties, including a tracking label.
 *
 * This satisfies the need for a tracking event to be sent with a label that is dynamic.
 */
import { unchangedEntities } from '../../tracking-utils/CustomiseEntities.utils';
import { useATFireUIInteractionEvent } from './ATFireUIInteractionEvent.hook';
export function useATTrackInteraction(args) {
    var interactionEvent = useATFireUIInteractionEvent();
    if (args !== undefined) {
        return function (callbackArgs) {
            var _a = callbackArgs !== null && callbackArgs !== void 0 ? callbackArgs : {}, _b = _a.customiseEntities, customiseEntities = _b === void 0 ? unchangedEntities : _b, interaction = _a.interaction, utagDimensions = _a.utagDimensions;
            return interactionEvent({
                customiseEntities: customiseEntities,
                interaction: interaction,
                utagDimensions: utagDimensions,
                trackingLabel: args.trackingLabel,
            });
        };
    }
    else {
        return function (callbackArgs) {
            var _a = callbackArgs.customiseEntities, customiseEntities = _a === void 0 ? unchangedEntities : _a, interaction = callbackArgs.interaction, utagDimensions = callbackArgs.utagDimensions, trackingLabel = callbackArgs.trackingLabel;
            return interactionEvent({
                customiseEntities: customiseEntities,
                interaction: interaction,
                utagDimensions: utagDimensions,
                trackingLabel: trackingLabel,
            });
        };
    }
}
